var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBentoTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.41797 15.3749V4.625L16.9275 9.99996L3.41797 15.3749ZM4.50128 13.7708L13.9596 9.99996L4.50128 6.22912V8.66023L8.52047 9.99996L4.50128 11.3397V13.7708Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBentoTelegramIcon);
export default __webpack_public_path__ + "static/media/bento-telegram-icon.bb914dfa61ef44c346036e153c61517b.svg";
export { ForwardRef as ReactComponent };